<template>
  <div>
    <el-button circle type="text" @click="handleOpenDialog" id="toggle-open-icn">
      <FAIcon :custom-style="{ 'margin-right': 0 }" :color="Colors.MAIN_THEME" icon="fas fa-database" />
    </el-button>

    <el-dialog :visible.sync="isOpenDialog" width="40%" id="source-dialog">
      <div id="sources-manager-header">Quản lý nguồn</div>
      <div id="sources-manager-body">
        <el-tabs v-model="activeTagName">
          <el-tab-pane label="Tất cả các nguồn" name="all-sources" class="list-source">
            <el-tree
              :data="sourcesData"
              :props="defaultProps"
              show-checkbox
              @check="updateAllSourcesCheckedStatus"
              accordion
              ref="allSourceTree"
              node-key="id"
              class="data-tree"
            >
              <span
                class="custom-tree-node"
                slot-scope="{ node, data }"
                style="max-width: calc(90%); display: flex; flex-direction: row; justify-content: space-between"
              >
                <div style="max-width: calc(78%)">
                  <p v-if="data.title != null">{{ data.title }}</p>

                  <a v-if="node.isLeaf" :href="data.label" target="_blank" class="source-link">{{ data.label }}</a>
                  <span v-else>{{ data.label }}</span>
                </div>
                <!--                                <div class="score" :class="{'score-root': !node.isLeaf}"-->
                <!--                                      v-if="!node.expanded">{{ data.score }}%</div>-->
              </span>
            </el-tree>
          </el-tab-pane>
          <el-tab-pane label="Các nguồn đã loại bỏ" name="blocked-sources" class="list-source">
            <el-tree
              :data="formattedBlockedData"
              :props="defaultProps"
              ref="blockedSourceTree"
              @check="updateBlockedSourcesCheckedStatus"
              show-checkbox
              accordion
              node-key="id"
              class="data-tree"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <p v-if="data.title != null">{{ data.title }}</p>

                <a v-if="node.isLeaf" :href="data.label" target="_blank" class="source-link">{{ data.label }}</a>
                <span v-else>{{ data.label }}</span>
                <!--                                <span class="score" :class="{'score-root': !node.isLeaf}"-->
                <!--                                      v-if="!node.expanded">{{ data.score }}%</span>-->
              </span>
            </el-tree>
          </el-tab-pane>
        </el-tabs>
        <div id="btn-container">
          <el-button @click="handleCloseDialog">Đóng</el-button>
          <div v-if="!isGroupResult" class="action-btn-container">
            <el-button
              :type="allowButtonType"
              @click="removeLink"
              v-if="activeTagName === 'all-sources'"
              :disabled="isAllSourcesCheckedEmpty"
              :loading="isUpdating"
            >
              Loại trừ
            </el-button>
            <el-button
              :type="removeButtonType"
              @click="allowLink"
              v-else-if="activeTagName === 'blocked-sources'"
              :disabled="isBlockedSourcesCheckedEmpty"
              :loading="isUpdating"
            >
              Cho phép
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getHostName } from '@/helpers/StringHelper'
import FAIcon from '@/components/common/FAIcon.vue'
import _ from 'lodash'
import { Colors, DocumentTypes } from '@/constants/DoITConstant'

export default {
  name: 'SourcesManager',
  props: ['blockedData'],
  components: {
    FAIcon,
  },
  data: () => {
    return {
      isOpenDialog: false,
      activeTagName: 'all-sources',
      defaultProps: {
        children: 'children',
        label: 'label',
        disabled: 'disabled',
        title: 'title',
        score: 'score',
      },
      allSourcesCheckedList: [],
      blockedSourcesCheckedList: [],
      isAllSourcesCheckedEmpty: true,
      isBlockedSourcesCheckedEmpty: true,
      sourcesData: [],
      formattedBlockedData: [],
      allowedChildMap: new Map(),
      blockedChildMap: new Map(),
      isUpdating: false,
      Colors,
    }
  },
  async mounted() {
    const blockedDataById = _.keyBy(this.blockedData, (blocked) => blocked.targetId)
    const filteredSources = Object.values(this.similarSources).filter((source) => !blockedDataById[source.id])
    this.getSourcesData(filteredSources)

    const blockedIds = this.blockedData.map((val) => val.targetId)
    this.getBlockedSourcesData(blockedIds)
  },
  methods: {
    getSourcesData(sources) {
      this.allowedChildMap = new Map()

      let t1 = performance.now()
      // let sourcesList = this.sourcesData
      let sourcesList = []

      let index = 0
      if (sourcesList.length > 0) {
        const lastSource = sourcesList[sourcesList.length - 1]
        index = lastSource.children[lastSource.children.length - 1].id
      }
      sources.forEach((source) => {
        const hostName = getHostName(source)
        // const hostName = source.domain
        const currentDomainIndex = sourcesList.findIndex((elem) => elem.label === hostName)
        if (currentDomainIndex === -1) {
          sourcesList.push({
            id: ++index,
            label: hostName,
            score: 1,
            children: [
              {
                id: ++index,
                label: source.url,
                score: 1,
                title: source.title,
                sourceId: source.id,
              },
            ],
          })
          this.allowedChildMap.set(source.id, { dId: sourcesList.length - 1, cId: 0 })
        } else {
          let current = sourcesList[currentDomainIndex]
          if (!this.allowedChildMap.has(source.id)) {
            const childScore = 0
            current.children.push({
              id: ++index,
              label: source.url,
              title: source.title,
              score: childScore >= 1 ? Math.floor(childScore) : '<1',
              sourceId: source.id,
            })
            current.score += childScore
            current.score = Math.floor(current.score)
            this.allowedChildMap.set(source.id, { dId: currentDomainIndex, cId: current.children.length - 1 })
          }
        }
      })
      // sourcesList.forEach(dataList => {
      //     dataList.children.sort((a, b) => {
      //         if (a.score === '<1')
      //             return 101
      //         else if (b.score === '<1')
      //             return -101
      //         else
      //             return b.score - a.score
      //     })
      // })
      console.log('get data sources', performance.now() - t1)
      this.sourcesData = sourcesList
    },
    getBlockedSourcesData(blockedData) {
      this.blockedChildMap = new Map()

      const t1 = performance.now()
      // let sourcesList = this.formattedBlockedData
      let sourcesList = []

      const lastSource = sourcesList[sourcesList.length - 1]
      let index = 0
      if (sourcesList.length > 0) {
        const lastSource = sourcesList[sourcesList.length - 1]
        index = lastSource.children[lastSource.children.length - 1].id
      }
      blockedData.forEach((sourceId) => {
        const source = this.similarSources[sourceId]
        const hostName = getHostName(source)
        // const hostName = source.domain
        const currentDomainIndex = sourcesList.findIndex((elem) => elem.label === hostName)
        if (currentDomainIndex === -1) {
          sourcesList.push({
            id: ++index,
            label: hostName,
            score: 1,
            children: [
              {
                id: ++index,
                label: source.url,
                score: 1,
                title: source.title,
                sourceId: source.id,
              },
            ],
          })
          this.blockedChildMap.set(source.id, { dId: sourcesList.length - 1, cId: 0 })
        } else {
          let current = sourcesList[currentDomainIndex]
          if (!this.blockedChildMap[source.id]) {
            let childScore = 0
            current.children.push({
              id: ++index,
              label: source.url,
              title: source.title,
              score: childScore >= 1 ? Math.floor(childScore) : '<1',
              sourceId: source.id,
            })
            current.score += childScore
            current.score = Math.floor(current.score)
            this.blockedChildMap.set(source.id, { dId: currentDomainIndex, cId: current.children.length - 1 })
          } else {
            console.log('go go')
          }
        }
      })
      // sourcesList.forEach(dataList => {
      //     dataList.children.sort((a, b) => {
      //         if (a.score === '<1')
      //             return 101
      //         else if (b.score === '<1')
      //             return -101
      //         else
      //             return b.score - a.score
      //     })
      // })
      console.log('get data sources', performance.now() - t1)
      this.formattedBlockedData = sourcesList
    },
    removeBlockedSourcesData(removeIds) {
      removeIds.forEach((removeId) => {
        const pos = this.blockedChildMap.get(removeId)
        if (pos) {
          const domain = this.formattedBlockedData[pos.dId]
          if (domain) {
            domain.children.splice(pos.cId, 1)
            if (domain.children.length === 0) this.formattedBlockedData.splice(pos.dId, 1)
          }

          this.blockedChildMap.delete(removeId)
        }
      })
    },
    removeSourcesData(removeIds) {
      console.log('all remove ids', removeIds)
      removeIds.forEach((removeId) => {
        const pos = this.allowedChildMap.get(removeId)
        if (pos) {
          const domain = this.sourcesData[pos.dId]
          if (domain) {
            const removed = domain.children.splice(pos.cId, 1)
            // if (removed)
            console.log('no remove', removed)
            if (domain.children.length === 0) {
              this.sourcesData.splice(pos.dId, 1)
            }
          } else {
            console.log('no domain')
          }
          this.allowedChildMap.delete(removeId)
        } else {
          console.log('no pos')
        }
      })
    },
    updateAllSourcesCheckedStatus(node, status) {
      this.isAllSourcesCheckedEmpty = status.checkedNodes == null || status.checkedNodes.length === 0
      this.allSourcesCheckedList = status.checkedNodes
    },
    updateBlockedSourcesCheckedStatus(node, status) {
      this.isBlockedSourcesCheckedEmpty = status.checkedNodes == null || status.checkedNodes.length === 0
      this.blockedSourcesCheckedList = status.checkedNodes
    },
    removeLink(node, status) {
      let linkData = this.$refs.allSourceTree.getCheckedNodes()
      // this.isUpdating = true
      this.$emit('updateSource', this.getUpdateSourceFormat(linkData))
      this.$refs.allSourceTree.setCheckedKeys([])
      this.allSourcesCheckedList = []
      this.isAllSourcesCheckedEmpty = true
      // this.isUpdating = false
      this.handleCloseDialog()
    },
    allowLink(node, status) {
      let linkData = this.$refs.blockedSourceTree.getCheckedNodes()
      // this.isUpdating = true
      this.$emit('updateSource', this.getUpdateSourceFormat(linkData))
      this.$refs.blockedSourceTree.setCheckedKeys([])
      this.blockedSourcesCheckedList = []
      this.isBlockedSourcesCheckedEmpty = true
      // this.isUpdating = false
      this.handleCloseDialog()
    },
    getUpdateSourceFormat(linkData) {
      let ids = []
      linkData.forEach((link) => {
        if (link.sourceId) {
          ids.push(link.sourceId)
        }
      })
      return { domains: [], sourceIds: ids }
    },
    handleOpenDialog() {
      this.isOpenDialog = true
    },
    handleCloseDialog() {
      this.isOpenDialog = false
    },
    // getName(source) {
    //     const type = getDocumentSourceType(source.url)
    //     if (type === DocumentSourceType.WEB)
    //         return source.domain
    //     if (type === DocumentSourceType.GROUP)
    //         return source
    // }
  },
  computed: {
    allowButtonType() {
      if (this.allSourcesCheckedList == null || this.allSourcesCheckedList.length === 0) return ''
      return 'primary'
    },
    removeButtonType() {
      if (this.blockedSourcesCheckedList == null || this.blockedSourcesCheckedList.length === 0) return ''
      return 'primary'
    },
    documentInfo() {
      return this.$store.getters['docRes/documentInfoCurrent']
    },
    similarSources() {
      return this.$store.getters['docRes/plagiarism/getAllSimilarSources']
    },
    isGroupResult() {
      return this.$route.params.type === DocumentTypes.GROUP_DOCUMENT
    },
  },
  watch: {
    blockedData: function (newVal, oldVal) {
      // const ti = performance.now()
      // const newIds = newVal.map(val => val.targetId).sort()
      // const oldIds = oldVal.map(val => val.targetId).sort()
      // const newBlockedData = _.difference(newIds, oldIds)
      // const newAllowedData = _.difference(oldIds, newIds)
      // console.log('deny: ', newBlockedData)
      // console.log('allowed: ', newAllowedData)
      //
      // this.getBlockedSourcesData(newBlockedData)
      // this.removeBlockedSourcesData(newAllowedData)
      //
      // const allowedSources = newAllowedData.map(id => this.similarSources[id])
      // this.getSourcesData(allowedSources)
      // this.removeSourcesData(newBlockedData)
      // console.log('allDiff: ', performance.now() - ti)

      const blockedDataById = _.keyBy(this.blockedData, (blocked) => blocked.targetId)
      const filteredSources = Object.values(this.similarSources).filter((source) => !blockedDataById[source.id])
      this.getSourcesData(filteredSources)

      const blockedIds = this.blockedData.map((val) => val.targetId)
      this.getBlockedSourcesData(blockedIds)
    },
  },
}
</script>

<style>
.data-tree .el-tree-node.is-expanded > .el-tree-node__children {
  overflow-x: auto;
}

.el-tree-node__children::-webkit-scrollbar:horizontal {
  height: 5px;
}

.el-tree-node__children::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.el-tree-node__children::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}

.el-tree-node__children::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: rgba(94, 95, 171, 0.15);
}

.el-tree-node__children::-webkit-scrollbar-thumb:hover {
  background-color: rgba(44, 45, 82, 0.7);
}

.el-tree-node__children:hover::-webkit-scrollbar-thumb {
  background-color: rgba(94, 95, 171, 0.5);
}

.el-tree-node__children {
  margin-bottom: 8px;
}

.el-tree-node .el-tree-node__content {
}

.el-tree-node__children .el-tree-node .el-tree-node__content {
  height: 47px;
  margin-bottom: 8px;
}

.el-tree-node__content:hover .custom-tree-node .score,
.el-tree-node__children .is-current .el-tree-node__content .custom-tree-node .score {
  background-color: #f5f7fa;
}
</style>

<style scoped>
.data-tree {
}

.list-source {
}

#toggle-open-icn {
  background-color: #fbfbfb;
  color: #3d5396;
  margin-right: 10px;
}

#sources-manager-header {
  font-size: 25px;
  font-weight: 600;
  margin-top: -40px;
  margin-bottom: 20px;
}

#source-dialog {
  /*min-width: 300px;*/
}

#sources-manager-body {
  width: 80%;
  margin: auto;
}

#btn-container {
  margin-top: 10px;
  text-align: right;
}

.source-link {
  color: gray;
}

.score {
  position: absolute;
  width: 50px;
  right: 0;
  height: 47px;
  color: #ffa054;
  margin-top: -10px;
  padding-top: 16px;
  /*font-size: 16px;*/
  font-weight: 600;
  background-color: #fff;
  padding-left: 15px;
}

.score-root {
  margin-top: -9px;
  padding-top: 8px;
  height: 26px;
  /*font-size: 14px;*/
}

.custom-tree-node {
  line-height: 0.5;
}

.action-btn-container {
  display: inline-block;
  margin-left: 15px;
}
</style>
